<div
    *ngIf="active"
    #overlay
    class="full-screen-loader"
    role="alert"
    aria-live="assertive"
    aria-busy="true"
    tabindex="-1">
    <jv-spinner
        size="lg"
        diameter="80"
        thickness="6"
        color="primary-1"
        track-color="gray-3"
        [attr.aria-label]="message">
    </jv-spinner>
</div>
